import React, { useEffect, useState } from 'react'
import { HashLink as Link } from 'react-router-hash-link'
import BarChart from '../components/BarChart'
import {questions, recommendations, titles, explanations, radar_options} from '../data/json'
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';
import Button from '../components/Button';
import { NavLink } from 'react-router-dom';

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);


const TestResult = ({values}) => {

  // Scroll to top
  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
    });
  }, [])

  const sendEmailAPI = 'https://localhost:44394/api/SendEmail';

  const [newEmail, setNewEmail] = useState("");

  const [showEmailSent, setShowEmailSent] = useState(false)

  // QUESTIONNAIRE RESULTS WITH THEIR CORRESPONDING QUESTION AND A SHORTER VERSION OF THE QUESTION TO INCLUDE IN THE GRAPHS
  const results = {

    economy: {
      result2_1: {
        qst_short: "Afkast på udviklingsprojekter",
        qst: questions.economy.qst_1,
        value: values.qst2_1
      },
      result2_2: {
        qst_short: "Profit",
        qst: questions.economy.qst_2,
        value: values.qst2_2
      },
      result2_3: {
        qst_short: "Planlægnings- og budgetprocesser",
        qst: questions.economy.qst_3,
        value: values.qst2_3
      },
      result2_4: {
        qst_short: "Kontrol af omkostninger",
        qst: questions.economy.qst_4,
        value: values.qst2_4
    }}, 
    strategy: {
      result3_1: {
        qst_short: "Imødekomme forandringer i markedet",
        qst: questions.strategy.qst_1,
        value: values.qst3_1
      },
      result3_2: {
        qst_short: "Drift og ressourceallokering",
        qst: questions.strategy.qst_2,
        value: values.qst3_2
      },
      result3_3: {
        qst_short: "Vurdering af strategisk værdi",
        qst: questions.strategy.qst_3,
        value: values.qst3_3
      },
      result3_4: {
        qst_short: "Risikovurdering og beslutningstagning",
        qst: questions.strategy.qst_4,
        value: values.qst3_4
    }},
    culture : {
      result4_1: {
        qst_short: "Udvikling af nye kompetencer",
        qst: questions.culture.qst_1,
        value: values.qst4_1
      },
      result4_2: {
        qst_short: "Inddragelse af medarbejdere",
        qst: questions.culture.qst_2,
        value: values.qst4_2
      },
      result4_3: {
        qst_short: "Interne politikker",
        qst: questions.culture.qst_3,
        value: values.qst4_3
      },
      result4_4: {
        qst_short: "Plan for fortsat drift",
        qst: questions.culture.qst_4,
        value: values.qst4_4
      },
      result4_5: {
        qst_short: "Kompetencer internt og eksternt",
        qst: questions.culture.qst_5,
        value: values.qst4_5
    }},
    resources : {
      result5_1: {
        qst_short: "Reagere på markedsændringer",
        qst: questions.resources.qst_1,
        value: values.qst5_1
      },
      result5_2: {
        qst_short: "Scanning af forretningsmiljøet",
        qst: questions.resources.qst_2,
        value: values.qst5_2
      },
      result5_3: {
        qst_short: "Pålidelige driftssystemer",
        qst: questions.resources.qst_3,
        value: values.qst5_3
      },
      result5_4: {
        qst_short: "Levering ved ressourcebegrænsninger",
        qst: questions.resources.qst_4,
        value: values.qst5_4
      },
      result5_5: {
        qst_short: "Deling af indsigt of erfaring",
        qst: questions.resources.qst_5,
        value: values.qst5_5
    }},
    market: {
      result6_1: {
        qst_short: "Relationer til kunder og leverandører",
        qst: questions.market.qst_1,
        value: values.qst6_1
      },
      result6_2: {
        qst_short: "Forandringer i markedet",
        qst: questions.market.qst_2,
        value: values.qst6_2
      },
      result6_3: {
        qst_short: "Kunders præferencer",
        qst: questions.market.qst_3,
        value: values.qst6_3
      },
      result6_4: {
        qst_short: "Kundeportfolio",
        qst: questions.market.qst_4,
        value: values.qst6_4
      },
      result6_5: {
        qst_short: "Konkurrence",
        qst: questions.market.qst_5,
        value: values.qst6_5
      }}
  }

  // CONVERTING FROM QUESTIONNAIRE VALUE TO A NUMBER BETWEEN 1 AND 5
  const dataConverter = (value) => {
    switch (value) {
      case "Meget uenig":
        return 1
      case "Uenig":
        return 2
      case "Hverken enig eller uenig":
        return 3
      case "Enig":
        return 4 
      case "Meget enig":
        return 5
      default:
        console.log("Cannot read values")
    }
  }

  // CALCULATES THE AVERAGE VALUE
  const avg_calculator = (values) => {
    var sum = 0;
    values.forEach(value => {
      sum += dataConverter(value.value)
    });
    return sum / values.length
  }

  const avg_results = (values) => {
    const avg_results = {average: {economy: 0, strategy: 0, culture: 0, resources: 0, market: 0}, sorted: {highest: "", highest_2:"", lowest: "", lowest_2: ""}}
    for ( var key in avg_results.average) {
      avg_results.average[key] = avg_calculator(Object.values(values[key]))
    }

    var sorted_avg = Object.entries(avg_results.average).sort(function(a, b) {
      return a[1] - b[1];
    })

    avg_results.sorted.highest = sorted_avg[sorted_avg.length-1][0]
    avg_results.sorted.highest_2 = sorted_avg[sorted_avg.length-2][0]
    avg_results.sorted.lowest = sorted_avg[0][0]
    avg_results.sorted.lowest_2 = sorted_avg[1][0]

    return avg_results
  }

  // CALCULATE THE CORRESPONDING SCORE (LOW, MIDDLE OR HIGH) DEPENDING ON THE VALUE
  const score_calculator = (value) => {
    if(value <= 2.5){
      return "LAV"
    } else if (value <= 3.5 && value >= 2.5){
      return "MIDDEL"
    }else if (value >= 3.5 && value < 6){
      return "HØJ"
    }
  }

  // DATA FOR THE RADAR CHART
  const radar_data = {
    labels: [titles.economy, titles.strategy, titles.culture, titles.resources, titles.market],
    datasets: [
      {
        label: '',
        data: [avg_results(results).average.economy, avg_results(results).average.strategy, avg_results(results).average.culture, avg_results(results).average.resources, avg_results(results).average.market],
        backgroundColor: 'rgba(85,201,162,0.5)',
        borderColor: '#266046',
        borderWidth: 2,
      },
    ],
  };

  // const updateEmail = e => {
  //   setNewEmail(e.target.value);
  // }

  // CONVERT RESULTS TO THE APPROPRIATE FORMAT FOR THE SERVER
  const resultsToServer = (results) => {

    var data = avg_results(results).average
    var resultsToServer = []
    var res = Object.keys(data).map(function(name){
      var obj = {};
      obj[name] = data[name];
      return obj;
    });
    resultsToServer = [ 
      { "key": Object.keys(res[0]).toString(), "value":  Number(Object.values(res[0]).toString()) },
      { "key": Object.keys(res[1]).toString(), "value":  Number(Object.values(res[1]).toString()) },
      { "key": Object.keys(res[2]).toString(), "value":  Number(Object.values(res[2]).toString()) },
      { "key": Object.keys(res[3]).toString(), "value":  Number(Object.values(res[3]).toString()) },
      { "key": Object.keys(res[4]).toString(), "value":  Number(Object.values(res[4]).toString()) }

    ]
    return (resultsToServer)   
  }


  const infoToPost = {
    email: newEmail,
    results: resultsToServer(results),
    answers: results
  }

  const SendEmail = e => {
    e.preventDefault();

    let json = JSON.stringify(infoToPost)
    console.log(json)
    console.log(results);

    fetch(sendEmailAPI, {
      method: 'POST',
      headers: {
        'Content-Type' : 'application/json'
      },
      body: json
    })
    .then(res => {
      if(res.status === 200) {
        console.log("POST OK")
        setNewEmail('')
        setShowEmailSent(true)       
      } else {
        console.log("POST FAILED")
      }
    })
  }

  return (
    <div className='__test-result'>
      <h2 className='mb-5 mt-5'>Resultat</h2>

      <div className='d-flex flex-column flex-lg-row gap-5 __highest-lowest-result'>
        <div className='__text-left'>
          <h4 className='mb-4'>Dine svar tyder på, at din virksomhed bør være opmærksom på sårbarheder inden for følgende områder: </h4>
          <div><Link to={`/test#chart_${ avg_results(results).sorted.lowest}`}><h1>{titles[avg_results(results).sorted.lowest]}</h1></Link> <p>{recommendations[avg_results(results).sorted.lowest]}</p></div> 
          <div><Link to={`/test#chart_${ avg_results(results).sorted.lowest_2}`}><h1>{titles[avg_results(results).sorted.lowest_2]}</h1></Link> <p>{recommendations[avg_results(results).sorted.lowest_2]}</p></div> 
          <div className=' mt-3 p-2 __to-scenarios'>
            <p>Er din virksomhed klar til fremtiden?</p>
            <div className='d-flex'>
              <p className='__to-scenarios-text'>Undersøg hvor godt din virksomhed ville klare sig i forskellige fremtidsscenarier. Prøv et tilfældigt scenario for at skabe dialog om fremtiden i jeres virksomhed.</p>
              <div className='__to-scenarios-button'>
                <NavLink to="/scenarios" target="_blank" rel="noopener noreferrer">
                  <Button buttonText='Gå til scenarier' colorGreen={false} />
                </NavLink>
                
              </div>
            </div>
          </div>
        </div>
        <div className='__text-right'>
          <h4 className='mb-4'>Dine svar tyder på, at I allerede er godt igang med følgende områder: </h4>
          <div><Link to={`/test#chart_${ avg_results(results).sorted.highest}`}><h1>{titles[avg_results(results).sorted.highest]}</h1></Link> <p>{explanations[avg_results(results).sorted.highest]}</p></div> 
          <div><Link to={`/test#chart_${ avg_results(results).sorted.highest_2}`}><h1>{titles[avg_results(results).sorted.highest_2]}</h1></Link> <p>{explanations[avg_results(results).sorted.highest_2]}</p></div>
        </div>
      </div>

      <div className='send-to-email'>
        <h1 className='mt-5'>Vil du gerne have resultaterne sendt til dig?</h1>
              <p>Indtast din e-mailadresse i feltet nedenfor, så sender vi en rapport til dig. Når du klikker 'Send', godkender du at vi gemmer dine kontaktoplysninger.</p> 
        <div>
          <input type='email' name='send_email' placeholder='Indtast e-mailadresse' value={newEmail} onChange={e=> setNewEmail(e.target.value)} />
          <Button buttonText='Send' onClick={SendEmail} type='submit' />
          {
            showEmailSent ? <div className='mt-2'>En rapport er sendt til din e-mail.</div> : <div></div>
          }
          
        </div>
      </div>


      <div className='mt-5'>
        <h4>Alle resultater</h4>
        <hr></hr>
        <div className='d-xl-flex flex-row-reverse'>
          <div className='__radar-container d-flex justify-content-center'>
            <Radar data={radar_data} options={radar_options} />
          </div>
          <div className='__charts-section'>
            <div id="chart_economy">
              <BarChart title={titles.economy} results={Object.values(results.economy)} toggleState={true} score={score_calculator(avg_results(results).average.economy)}  />
            </div>
            <div id="chart_market" >
              <BarChart title={titles.market} results={Object.values(results.market)} toggleState={true} score={score_calculator(avg_results(results).average.market)} />  
            </div>
            <div id="chart_strategy" >
              <BarChart title={titles.strategy} results={Object.values(results.strategy)} toggleState={true} score={score_calculator(avg_results(results).average.strategy)}  />
            </div>
            <div id="chart_resources" >
              <BarChart title={titles.resources} results={Object.values(results.resources)} toggleState={true} score={score_calculator(avg_results(results).average.resources)}  />
            </div>        
            <div id="chart_culture">
              <BarChart title={titles.culture} results={Object.values(results.culture)} toggleState={true} score={score_calculator(avg_results(results).average.culture)}  />    
            </div>  
          </div>
        </div>
      </div>
    </div>
  )
}

export default TestResult